export const formatCascadeLogDuration = (durationMs: number | null | undefined) => {
    if (durationMs == null) {
        return null;
    }

    return `${durationMs} ms`;
};
